// Bridge between "calendar-fixed" storage (monthly_values[0] = January,
// monthly_values[11] = December) and "scenario-display order" (index 0 =
// the scenario's start month, e.g. May when start_month = 4).
//
// All persistence is calendar-fixed. The UI rotates for display and rotates
// back when committing.

function clampStartMonth(m) {
  return Number.isInteger(m) && m >= 0 && m <= 11 ? m : 0;
}

// Calendar order [Jan..Dec] → scenario display order [start..start+11 mod 12].
export function rotateValuesForDisplay(values, startMonth) {
  const s = clampStartMonth(startMonth);
  const safe = (values || []).slice(0, 12);
  while (safe.length < 12) safe.push(0);
  const out = new Array(12);
  for (let i = 0; i < 12; i += 1) {
    out[i] = safe[(i + s) % 12];
  }
  return out;
}

// Scenario display order → calendar order [Jan..Dec]. Inverse of above.
export function rotateValuesFromDisplay(displayValues, startMonth) {
  const s = clampStartMonth(startMonth);
  const safe = (displayValues || []).slice(0, 12);
  while (safe.length < 12) safe.push(0);
  const out = new Array(12).fill(0);
  for (let i = 0; i < 12; i += 1) {
    out[(i + s) % 12] = safe[i];
  }
  return out;
}

// Display index (0..11 in scenario order) → calendar index (0=Jan..11=Dec).
export function displayIdxToCalendar(displayIdx, startMonth) {
  return (displayIdx + clampStartMonth(startMonth)) % 12;
}

// Calendar index → display index.
export function calendarIdxToDisplay(calendarIdx, startMonth) {
  return (calendarIdx - clampStartMonth(startMonth) + 12) % 12;
}
